var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"text-center date"},[_c('b-col',{staticClass:"p-0"},[_c('div',{},[_vm._v("— "+_vm._s(_vm.itemData.tempMonth)+" "+_vm._s(_vm.itemData.tempDay)+" —")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }